// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CollectionTypeService from '@services/collection-type'

export const getAllDonation = createAsyncThunk('donation/getAllDonation', async (params, { rejectWithValue }) => {
  try {
    const response = await CollectionTypeService.getAllDonation(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getDonationById = createAsyncThunk('donation/getDonationById', async (id) => {
  const response = await CollectionTypeService.getDonationById(id)
  return response
})

export const addDonation = createAsyncThunk('donation/addDonation', async (donation, { rejectWithValue }) => {
  try {
    const response = await CollectionTypeService.addDonation(donation)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateDonation = createAsyncThunk('donation/updateDonation', async (donation, { rejectWithValue }) => {
  try {
    const response = await CollectionTypeService.updateDonation(donation)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteDonation = createAsyncThunk('donation/deleteDonation', async (id, { dispatch, getState }) => {
  await CollectionTypeService.deleteDonation(id)
  await dispatch(getAllDonation(getState()?.donations.params))
  return id
})

export const donationSlice = createSlice({
  name: 'donations',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualDonation: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllDonation.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getDonationById.fulfilled, (state, action) => {
        state.individualDonation = action.payload
        state.loading = false
      })
      .addCase(getDonationById.pending, (state, action) => {
        state.individualDonation = action.payload
        state.loading = true
      })
      .addCase(getDonationById.rejected, (state, action) => {
        state.individualDonation = action.payload
        state.loading = false
      })
  }
})

export default donationSlice.reducer
